<div class="header-wrapper">
  <span class="header-label" [title]="params.displayName">{{params.displayName}}</span>
  <button #resetWeekBtn *ngIf="isResetAvailable()" title="{{  'plan.dist.reset.btn' | translate}}" [attr.aria-label]="'plan.dist.reset.btn' | translate"
        [disabled]="isDisabled()"
        type="button" class="esp-grid-header-btn reset-week-btn" data-testid="reset-week-icon"
        #resetPopover="ngbPopover" [ngbPopover]="confirmReset" triggers="click" container="body" popoverClass="reset-popup"
        (shown)="onConfirmShown()" (hidden)="onConfirmHidden()"><esp-icon name="undo-2"></esp-icon></button>
</div>

<ng-template #confirmReset>
  <div role="dialog" aria-labelledby="reset-week-confirm-title" tabindex="-1" (keydown.tab)="onConfirmDialogTab($event)">
    <div class="message-text">
      <p id="reset-week-confirm-title">{{"plan.dist.reset.msg.body" | translate }} </p>
    </div>
    <div class="button-response">
      <breeze-button [isSecondary]="true" [showTooltip] = "false" buttonText="{{'btn.cancel.label' | translate }}" (clicked)="resetPopover.close()"></breeze-button>
      <breeze-button [isPrimary]="true" [showTooltip] = "false" buttonText="{{'btn.confirm.label' | translate }}" (clicked)="resetColumn()"></breeze-button>
    </div>
  </div>
</ng-template>

